import { HttpErrorResponse } from '@angular/common/http';
import { Component, TemplateRef, ViewChild, inject, input, output, signal } from '@angular/core';

import { Subject, combineLatest } from 'rxjs';

import { CamAddEventRequest } from '@camelot/calendar';
import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput, IInputsError } from '@camelot/form-model';
import { ENotificationCode, LAZY_SERVICE_TOKEN } from '@camelot/notification';
import { CamBaseComponent, TypedTemplateDirective, fullName } from '@camelot/utils';

import { NoteType } from '../../../services/dto/note-type';
import { CamCalendarNoteFormService } from '../../../services/form/calendar-note.service';
import { CamNotesService } from '../../../services/notes.service';

@Component({
  selector: 'cam-create-note-form',
  imports: [FormComponent, TypedTemplateDirective],
  templateUrl: './create-note.component.html',
  styleUrl: './create-note.component.scss',
})
export class CreateNoteFormComponent extends CamBaseComponent {
  data = input<CamAddEventRequest>();

  askValidation = input.required<Subject<null>>();

  loader = input(false);
  error = input<IInputsError>({ message: '', status: ENotificationCode.none });

  isFormValid = output<boolean>();

  added = output<void>();

  @ViewChild('userTemplate', { read: TemplateRef }) userTemplate!: TemplateRef<void>;
  @ViewChild('noteTypeTemplate', { read: TemplateRef }) noteTypeTemplate!: TemplateRef<void>;

  private _formService = inject(CamCalendarNoteFormService);
  private _calendarNotesEventService = inject(CamNotesService);

  public readonly form = signal<CamAbstractInput[]>([]);
  public readonly fullName = fullName;

  public readonly typeNoteTypeToken!: { item: NoteType };
  protected _notificationService = inject(LAZY_SERVICE_TOKEN);

  ngAfterViewInit() {
    this.form.set(
      this._formService.getEventForm(
        {
          noteType: this.noteTypeTemplate,
        },
        this.data()
      )
    );
  }

  public validation(data: any) {
    this.requestState.asked();

    const notes = this._formService.formatEventForm(data);
    this._registerSubscription(
      combineLatest(notes.map(note => this._calendarNotesEventService.createCalendarNote$(note))).subscribe({
        complete: () => {
          this.requestState.completed();
          this._notificationService.addNotification('notification.common.success', ENotificationCode.success);
          this.added.emit();
        },
        error: (error: HttpErrorResponse) => {
          this.requestState.onError(error.status, error.statusText);
        },
      })
    );
  }
}
